
const initialState = {
    allThreads: [],
    trending: [],
    userQuestions: [],
    userAnswers: [],
    communityTotalQuestionsCount:null,
    totalAnswersCount:null,
    userQuestionsCount:null,
    userQuestionAnswersCount:null,
};

export const COMMUNITY_ACTION_TYPES = {
    SET_ALL_THREADS: "SET_ALL_THREADS",
    SET_TRENDING: "SET_TRENDING",
    SET_USER_QUESTIONS: "SET_USER_QUESTIONS",
    SET_USER_ANSWERS: "SET_USER_ANSWERS",
    SET_TOTAL_QUESTIONS_COUNT: "SET_TOTAL_QUESTIONS_COUNT",
    SET_TOTAL_ANSWER_COUNT: "SET_TOTAL_ANSWER_COUNT",
    SET_USER_QUESTIONS_COUNT: "SET_USER_QUESTIONS_COUNT",
    SET_USER_QUESTION_ANSWERS_COUNT: "SET_USER_ANSWERS_COUNT",
}

const communityReducer = (state = initialState, action) => {
    switch (action.type) {
        case COMMUNITY_ACTION_TYPES.SET_ALL_THREADS:
            return {
                ...state,
                allThreads: action.payload,
            };
        case COMMUNITY_ACTION_TYPES.SET_TRENDING:
            return {
                ...state,
                trending: action.payload,
            }
        case COMMUNITY_ACTION_TYPES.SET_USER_QUESTIONS:
            return {
                ...state,
                userQuestions: action.payload,
            }
        case COMMUNITY_ACTION_TYPES.SET_USER_ANSWERS:
            return {
                ...state,
                userAnswers: action.payload,
            }
        case COMMUNITY_ACTION_TYPES.SET_TOTAL_QUESTIONS_COUNT:
            return {
                ...state,
                communityTotalQuestionsCount: action.payload,
            }
        case COMMUNITY_ACTION_TYPES.SET_TOTAL_ANSWER_COUNT:
            return {
                ...state,
                totalAnswersCount: action.payload,
            }
        case COMMUNITY_ACTION_TYPES.SET_USER_QUESTIONS_COUNT:
            return {
                ...state,
                userQuestionsCount: action.payload
            }
        case COMMUNITY_ACTION_TYPES.SET_USER_QUESTION_ANSWERS_COUNT:
            return {
                ...state,
                userQuestionAnswersCount: action.payload,
            }
        default:
            return state;
    }
};

export default communityReducer;
